import { styled } from '@linaria/react';

const Dl = styled.dl`
  height: 100%;
  min-width: 0px;
  text-align: center;

  dt {
    font-size: 0.875rem;
    hyphens: auto;
    line-height: 1.1;

    &[data-prop] {
      font-family: var(--font-family-mono);
      font-size: 0.8rem;
      line-height: 1.1;
    }
  }

  dd {
    margin-bottom: 1em;
  }

  dt,
  dd {
    transition: opacity 200ms;
  }
`;

export default Dl;
